import { validateLowerCase, validateUpperCase, validateLowerAndUpper, validatePhone, validateOrderNum } from './validate';
import { getToken, removeToken, setToken } from './auth';
import { _cloneDeep, _isArray, _isNumber, _isObject, _isString, _isEmpty } from './lodash';
import unifyFormat from './unifyformat';
import { parseQueryString } from './parse';
// todo 删除
import url from './url';
import elDateLimit from './ElDateLimit';
import validate from './validate_fromklicen';
// import ajax from './ajax';
import cookie from './cookie';
import regular from './regular';
import checkChange from './checkChange';
import getBase64Img from './getBase64img';
import formatDate from './formatdate';
// import _http from './http';
import localStorage from './localStorage';
import download from './downloadFile';
import recurseToTree0 from './recurseToTree.js';

export {
  // Token
  getToken,
  removeToken,
  setToken,
  // validate
  validateLowerCase,
  validateUpperCase,
  validateLowerAndUpper,
  validatePhone,
  validateOrderNum,
  // lodash
  _cloneDeep,
  _isArray,
  _isNumber,
  _isObject,
  _isString,
  _isEmpty,
  // dateTranslate
  unifyFormat,
  // parse
  parseQueryString,
  download,
};

// 将权限数据转成树状数据结构
export function restoreUserAuthorities(userAuthorities) {
  let uas = [];
  /* eslint-disable */
  for (let i = 0, length = userAuthorities.length; i < length; i++) {
    const userAuthorition = userAuthorities[i];
    if(userAuthorition.children && userAuthorition.children.length > 0){
      uas = [...uas,...restoreUserAuthorities(userAuthorition.children)];
    }
    uas.push(userAuthorition);
  }
  /* eslint-enable */
  return uas;
}

/**
 * 获取指定权限的所有子权限
 * @param {*} userAuthorities 所有权限
 * @param {*} id 当前权限id
 */
export function childrenCollections(userAuthorities = [], id) {
  const newSelectAuthorities = [];
  userAuthorities.forEach((item) => {
    if (item.id === id) {
      newSelectAuthorities.push(item.id);
    } else if (item.parentId === id || item.topId === id) {
      const childrenAuthorities = childrenCollections(userAuthorities, item.id);
      if (childrenAuthorities.length > 0) {
        childrenAuthorities.forEach((id2) => {
          newSelectAuthorities.push(id2);
        });
      }
      newSelectAuthorities.push(item.id);
    }
  });
  return [...new Set(newSelectAuthorities)];
}

// todo 删除
export const Url = url;
export const Validate = validate;
// export const Ajax = ajax;
export const ElDateLimit = elDateLimit;
export const Cookie = cookie;
export const Regular = regular;
export const CheckChange = checkChange;
export const GetBase64Img = getBase64Img;
export const FormatDate = formatDate;
export const UnifyFormat = unifyFormat;
// export const http = _http;
export const LocalStorage = localStorage;
export const recurseToTree = recurseToTree0;
